import React from "react"
import { AppFeaturesPage } from "./AppFeaturesPage"
import { AppFeaturesPersonalTab } from "./AppFeaturesPersonalTab/AppFeaturesPersonalTab"
import { AppFeaturesGroupTab } from "./AppFeaturesGroupTab/AppFeaturesGroupTab"
import { AppFeaturesMeetingExt } from "./AppFeaturesMeetingExt/AppFeaturesMeetingExt"
import { AppFeaturesActivity } from "./AppFeaturesActivity/AppFeaturesActivity"
import { AppFeaturesBot } from "./AppFeaturesBot/AppFeaturesBot"
import { AppFeaturesME } from "./AppFeaturesME/AppFeaturesME"
export const AppFeatureRoutes = () => {
  const routes = [
    {
      path: '',
      element: <AppFeaturesPage />
    },
    {
      path: 'personal-app',
      element: <AppFeaturesPersonalTab />
    },
    {
      path: 'channel-and-group-app',
      element: <AppFeaturesGroupTab />
    },
    {
      path: 'meeting-app',
      element: <AppFeaturesMeetingExt />
    },
    {
      path: 'activity',
      element: <AppFeaturesActivity />
    },
    {
      path: 'bot',
      element: <AppFeaturesBot />
    },
    {
      path: 'messaging-extension',
      element: <AppFeaturesME />
    }
  ]

  return routes
}
